/**
 * @flow
 * @relayHash c1787aa685939ee5bf4ed2e60d30a8ca
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AddUpdateRunModal_job$ref = any;
type AddUpdateRunModal_run$ref = any;
type DeleteRunModal_run$ref = any;
type OperatorControls_run$ref = any;
type RunLogs_run$ref = any;
type RunYieldCard_runYield$ref = any;
type RunYields_run$ref = any;
export type RunStatus = "COMPLETE" | "IN_PROGRESS" | "PAUSED" | "SCHEDULED";
export type RunDetailsPanelQueryVariables = {|
  id: string
|};
export type RunDetailsPanelQueryResponse = {|
  +viewer: ?{|
    +id: string,
    +company: {|
      +id: string,
      +scheduleAllowRunLogEdit: boolean,
    |},
  |},
  +run: {|
    +id: string,
    +scheduledStartAt: any,
    +scheduledEndAt: any,
    +actualStartAt: ?any,
    +actualEndAt: ?any,
    +status: RunStatus,
    +notes: ?string,
    +job: {|
      +id: string,
      +jobNumber: string,
      +name: string,
      +order: ?{|
        +id: string,
        +customer: {|
          +id: string,
          +name: string,
        |},
      |},
      +user: ?{|
        +id: string,
        +firstName: string,
        +lastName: string,
      |},
      +$fragmentRefs: AddUpdateRunModal_job$ref,
    |},
    +jobState: {|
      +id: string,
      +workflowState: {|
        +id: string,
        +name: string,
      |},
    |},
    +machine: {|
      +id: string,
      +name: string,
    |},
    +yields: {|
      +edges: ?$ReadOnlyArray<?{|
        +node: {|
          +id: string,
          +quantity: number,
          +item: {|
            +id: string,
            +name: string,
            +partNumber: ?string,
            +description: ?string,
            +quantityUOM: {|
              +id: string,
              +symbol: string,
            |},
          |},
          +$fragmentRefs: RunYieldCard_runYield$ref,
        |},
        +defectQuantity: ?number,
        +runQuantity: ?number,
        +setupQuantity: ?number,
      |}>
    |},
    +$fragmentRefs: OperatorControls_run$ref & RunYields_run$ref & RunLogs_run$ref & AddUpdateRunModal_run$ref & DeleteRunModal_run$ref,
  |},
|};
export type RunDetailsPanelQuery = {|
  variables: RunDetailsPanelQueryVariables,
  response: RunDetailsPanelQueryResponse,
|};
*/


/*
query RunDetailsPanelQuery(
  $id: ID!
) {
  viewer {
    id
    company {
      id
      scheduleAllowRunLogEdit
    }
  }
  run(id: $id) {
    id
    scheduledStartAt
    scheduledEndAt
    actualStartAt
    actualEndAt
    status
    notes
    ...OperatorControls_run
    ...RunYields_run
    ...RunLogs_run
    ...AddUpdateRunModal_run
    ...DeleteRunModal_run
    job {
      id
      jobNumber
      name
      ...AddUpdateRunModal_job
      order {
        id
        customer {
          id
          name
        }
      }
      user {
        id
        firstName
        lastName
      }
    }
    jobState {
      id
      workflowState {
        id
        name
      }
    }
    machine {
      id
      name
    }
    yields {
      edges {
        node {
          id
          quantity
          ...RunYieldCard_runYield
          item {
            id
            name
            partNumber
            description
            quantityUOM {
              id
              symbol
            }
          }
        }
        defectQuantity
        runQuantity
        setupQuantity
      }
    }
  }
}

fragment OperatorControls_run on Run {
  id
  ...RunControls_run
  ...SetupStartModal_run
  ...SetupPauseModal_run
  ...SetupEndModal_run
  ...RunStartModal_run
  ...RunPauseModal_run
  ...RunEndModal_run
}

fragment RunYields_run on Run {
  id
  yields {
    edges {
      defectQuantity
      setupQuantity
      runQuantity
      node {
        id
        item {
          id
          name
          quantityUOM {
            id
            symbol
          }
        }
      }
    }
  }
}

fragment RunLogs_run on Run {
  id
  yields {
    edges {
      setupQuantity
      runQuantity
      defectQuantity
      node {
        id
        item {
          id
          name
        }
      }
    }
  }
  machine {
    id
  }
  logs {
    id
    type
    notes
    createdAt
    user {
      ...UserWidget_user
      id
    }
  }
}

fragment AddUpdateRunModal_run on Run {
  id
  scheduledStartAt
  notes
  machine {
    id
    name
    type {
      id
    }
  }
  jobState {
    id
  }
  yields {
    edges {
      node {
        id
        item {
          id
          name
        }
      }
    }
  }
}

fragment DeleteRunModal_run on Run {
  id
  machine {
    id
    name
    type {
      id
      name
    }
  }
}

fragment AddUpdateRunModal_job on Job {
  id
  states {
    id
    isEnabled
    workflowState {
      id
      name
      machineType {
        id
      }
    }
  }
  yields {
    edges {
      node {
        id
        item {
          id
          name
        }
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}

fragment RunYieldCard_runYield on JobYield {
  id
  quantity
  item {
    id
    name
    partNumber
    description
    formFieldValues
    quantityUOM {
      id
      symbol
    }
    form {
      id
      ...FormBuilder_form
      fields {
        id
        systemKey
        name
        type
      }
    }
  }
}

fragment FormBuilder_form on Form {
  id
  name
  type
  systemKey
  productionType {
    id
  }
  fields {
    id
    systemKey
    type
    name
    description
    placeholder
    isRequired
    isCreatable
    applicationType
    displayOrder
    properties
    options {
      name
      value
      id
    }
  }
}

fragment UserWidget_user on User {
  id
  firstName
  lastName
  ...UserAvatar_user
}

fragment UserAvatar_user on User {
  id
  avatar
  firstName
}

fragment RunControls_run on Run {
  id
  setupTotalSeconds
  runTotalSeconds
  status
  logs {
    id
    type
    notes
    createdAt
    user {
      id
      ...ProgressPanel_user
    }
  }
}

fragment SetupStartModal_run on Run {
  id
  status
  machine {
    id
    type {
      id
      name
    }
  }
}

fragment SetupPauseModal_run on Run {
  id
  machine {
    id
    type {
      id
      name
    }
  }
}

fragment SetupEndModal_run on Run {
  id
  jobState {
    id
    workflowState {
      id
      isTrackingSetupQuantity
    }
  }
  yields {
    edges {
      node {
        id
        quantity
        item {
          id
          name
          partNumber
          quantityUOM {
            id
            symbol
          }
        }
      }
    }
  }
  machine {
    id
    type {
      id
      name
    }
  }
}

fragment RunStartModal_run on Run {
  id
  status
  machine {
    id
    type {
      id
      name
    }
  }
}

fragment RunPauseModal_run on Run {
  id
  machine {
    id
    type {
      id
      name
    }
  }
}

fragment RunEndModal_run on Run {
  id
  jobState {
    id
    workflowState {
      id
      trackRunQuantityType
      isPromptingFinalQuantity
      defaultLot {
        id
      }
    }
  }
  yields {
    edges {
      node {
        id
        quantity
        item {
          id
          name
          partNumber
          lotTracking
          quantityUOM {
            id
            symbol
          }
        }
      }
    }
  }
  machine {
    id
    type {
      id
      name
    }
  }
}

fragment ProgressPanel_user on User {
  id
  firstName
  lastName
  avatar
  ...UserAvatar_user
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "id",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "viewer",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "company",
      "storageKey": null,
      "args": null,
      "concreteType": "Company",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "scheduleAllowRunLogEdit",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v3 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "scheduledStartAt",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "scheduledEndAt",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actualStartAt",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "actualEndAt",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "status",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "notes",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "jobNumber",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v12 = [
  (v1/*: any*/),
  (v11/*: any*/)
],
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "order",
  "storageKey": null,
  "args": null,
  "concreteType": "Order",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "customer",
      "storageKey": null,
      "args": null,
      "concreteType": "Customer",
      "plural": false,
      "selections": (v12/*: any*/)
    }
  ]
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "firstName",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "lastName",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "user",
  "storageKey": null,
  "args": null,
  "concreteType": "User",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/)
  ]
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "quantity",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "partNumber",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "quantityUOM",
  "storageKey": null,
  "args": null,
  "concreteType": "UOM",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "symbol",
      "args": null,
      "storageKey": null
    }
  ]
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "defectQuantity",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "runQuantity",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "setupQuantity",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "type",
  "args": null,
  "storageKey": null
},
v25 = [
  (v1/*: any*/)
],
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "systemKey",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "RunDetailsPanelQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      (v2/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "run",
        "storageKey": null,
        "args": (v3/*: any*/),
        "concreteType": "Run",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "job",
            "storageKey": null,
            "args": null,
            "concreteType": "Job",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              (v13/*: any*/),
              (v16/*: any*/),
              {
                "kind": "FragmentSpread",
                "name": "AddUpdateRunModal_job",
                "args": null
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobState",
            "storageKey": null,
            "args": null,
            "concreteType": "JobState",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workflowState",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkflowState",
                "plural": false,
                "selections": (v12/*: any*/)
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "machine",
            "storageKey": null,
            "args": null,
            "concreteType": "Machine",
            "plural": false,
            "selections": (v12/*: any*/)
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "yields",
            "storageKey": null,
            "args": null,
            "concreteType": "RunYieldConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "RunYieldEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYield",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v11/*: any*/),
                          (v18/*: any*/),
                          (v19/*: any*/),
                          (v20/*: any*/)
                        ]
                      },
                      {
                        "kind": "FragmentSpread",
                        "name": "RunYieldCard_runYield",
                        "args": null
                      }
                    ]
                  },
                  (v21/*: any*/),
                  (v22/*: any*/),
                  (v23/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "FragmentSpread",
            "name": "OperatorControls_run",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "RunYields_run",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "RunLogs_run",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "AddUpdateRunModal_run",
            "args": null
          },
          {
            "kind": "FragmentSpread",
            "name": "DeleteRunModal_run",
            "args": null
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "RunDetailsPanelQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      (v2/*: any*/),
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "run",
        "storageKey": null,
        "args": (v3/*: any*/),
        "concreteType": "Run",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "setupTotalSeconds",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "runTotalSeconds",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "logs",
            "storageKey": null,
            "args": null,
            "concreteType": "RunLog",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v24/*: any*/),
              (v9/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "createdAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "user",
                "storageKey": null,
                "args": null,
                "concreteType": "User",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "avatar",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "machine",
            "storageKey": null,
            "args": null,
            "concreteType": "Machine",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "type",
                "storageKey": null,
                "args": null,
                "concreteType": "MachineType",
                "plural": false,
                "selections": (v12/*: any*/)
              },
              (v11/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "jobState",
            "storageKey": null,
            "args": null,
            "concreteType": "JobState",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "workflowState",
                "storageKey": null,
                "args": null,
                "concreteType": "WorkflowState",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isTrackingSetupQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "trackRunQuantityType",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isPromptingFinalQuantity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "defaultLot",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Lot",
                    "plural": false,
                    "selections": (v25/*: any*/)
                  },
                  (v11/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "yields",
            "storageKey": null,
            "args": null,
            "concreteType": "RunYieldConnection",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "edges",
                "storageKey": null,
                "args": null,
                "concreteType": "RunYieldEdge",
                "plural": true,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "node",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYield",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v17/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "item",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Item",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v11/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lotTracking",
                            "args": null,
                            "storageKey": null
                          },
                          (v19/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "formFieldValues",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "form",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Form",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v11/*: any*/),
                              (v24/*: any*/),
                              (v26/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "productionType",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProductionType",
                                "plural": false,
                                "selections": (v25/*: any*/)
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "fields",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "FormField",
                                "plural": true,
                                "selections": [
                                  (v1/*: any*/),
                                  (v26/*: any*/),
                                  (v24/*: any*/),
                                  (v11/*: any*/),
                                  (v19/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "placeholder",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isRequired",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "isCreatable",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "applicationType",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "displayOrder",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "properties",
                                    "args": null,
                                    "storageKey": null
                                  },
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "options",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "FormFieldOption",
                                    "plural": true,
                                    "selections": [
                                      (v11/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "alias": null,
                                        "name": "value",
                                        "args": null,
                                        "storageKey": null
                                      },
                                      (v1/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v21/*: any*/),
                  (v23/*: any*/),
                  (v22/*: any*/)
                ]
              }
            ]
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "job",
            "storageKey": null,
            "args": null,
            "concreteType": "Job",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              (v10/*: any*/),
              (v11/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "states",
                "storageKey": null,
                "args": null,
                "concreteType": "JobState",
                "plural": true,
                "selections": [
                  (v1/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "isEnabled",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "workflowState",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "WorkflowState",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v11/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "machineType",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "MachineType",
                        "plural": false,
                        "selections": (v25/*: any*/)
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "yields",
                "storageKey": null,
                "args": null,
                "concreteType": "JobYieldConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "JobYieldEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "JobYield",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": (v12/*: any*/)
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "__typename",
                            "args": null,
                            "storageKey": null
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "cursor",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "pageInfo",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "endCursor",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "hasNextPage",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              {
                "kind": "LinkedHandle",
                "alias": null,
                "name": "yields",
                "args": null,
                "handle": "connection",
                "key": "AddUpdateRunModal_job_yields",
                "filters": []
              },
              (v13/*: any*/),
              (v16/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "RunDetailsPanelQuery",
    "id": null,
    "text": "query RunDetailsPanelQuery(\n  $id: ID!\n) {\n  viewer {\n    id\n    company {\n      id\n      scheduleAllowRunLogEdit\n    }\n  }\n  run(id: $id) {\n    id\n    scheduledStartAt\n    scheduledEndAt\n    actualStartAt\n    actualEndAt\n    status\n    notes\n    ...OperatorControls_run\n    ...RunYields_run\n    ...RunLogs_run\n    ...AddUpdateRunModal_run\n    ...DeleteRunModal_run\n    job {\n      id\n      jobNumber\n      name\n      ...AddUpdateRunModal_job\n      order {\n        id\n        customer {\n          id\n          name\n        }\n      }\n      user {\n        id\n        firstName\n        lastName\n      }\n    }\n    jobState {\n      id\n      workflowState {\n        id\n        name\n      }\n    }\n    machine {\n      id\n      name\n    }\n    yields {\n      edges {\n        node {\n          id\n          quantity\n          ...RunYieldCard_runYield\n          item {\n            id\n            name\n            partNumber\n            description\n            quantityUOM {\n              id\n              symbol\n            }\n          }\n        }\n        defectQuantity\n        runQuantity\n        setupQuantity\n      }\n    }\n  }\n}\n\nfragment OperatorControls_run on Run {\n  id\n  ...RunControls_run\n  ...SetupStartModal_run\n  ...SetupPauseModal_run\n  ...SetupEndModal_run\n  ...RunStartModal_run\n  ...RunPauseModal_run\n  ...RunEndModal_run\n}\n\nfragment RunYields_run on Run {\n  id\n  yields {\n    edges {\n      defectQuantity\n      setupQuantity\n      runQuantity\n      node {\n        id\n        item {\n          id\n          name\n          quantityUOM {\n            id\n            symbol\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment RunLogs_run on Run {\n  id\n  yields {\n    edges {\n      setupQuantity\n      runQuantity\n      defectQuantity\n      node {\n        id\n        item {\n          id\n          name\n        }\n      }\n    }\n  }\n  machine {\n    id\n  }\n  logs {\n    id\n    type\n    notes\n    createdAt\n    user {\n      ...UserWidget_user\n      id\n    }\n  }\n}\n\nfragment AddUpdateRunModal_run on Run {\n  id\n  scheduledStartAt\n  notes\n  machine {\n    id\n    name\n    type {\n      id\n    }\n  }\n  jobState {\n    id\n  }\n  yields {\n    edges {\n      node {\n        id\n        item {\n          id\n          name\n        }\n      }\n    }\n  }\n}\n\nfragment DeleteRunModal_run on Run {\n  id\n  machine {\n    id\n    name\n    type {\n      id\n      name\n    }\n  }\n}\n\nfragment AddUpdateRunModal_job on Job {\n  id\n  states {\n    id\n    isEnabled\n    workflowState {\n      id\n      name\n      machineType {\n        id\n      }\n    }\n  }\n  yields {\n    edges {\n      node {\n        id\n        item {\n          id\n          name\n        }\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment RunYieldCard_runYield on JobYield {\n  id\n  quantity\n  item {\n    id\n    name\n    partNumber\n    description\n    formFieldValues\n    quantityUOM {\n      id\n      symbol\n    }\n    form {\n      id\n      ...FormBuilder_form\n      fields {\n        id\n        systemKey\n        name\n        type\n      }\n    }\n  }\n}\n\nfragment FormBuilder_form on Form {\n  id\n  name\n  type\n  systemKey\n  productionType {\n    id\n  }\n  fields {\n    id\n    systemKey\n    type\n    name\n    description\n    placeholder\n    isRequired\n    isCreatable\n    applicationType\n    displayOrder\n    properties\n    options {\n      name\n      value\n      id\n    }\n  }\n}\n\nfragment UserWidget_user on User {\n  id\n  firstName\n  lastName\n  ...UserAvatar_user\n}\n\nfragment UserAvatar_user on User {\n  id\n  avatar\n  firstName\n}\n\nfragment RunControls_run on Run {\n  id\n  setupTotalSeconds\n  runTotalSeconds\n  status\n  logs {\n    id\n    type\n    notes\n    createdAt\n    user {\n      id\n      ...ProgressPanel_user\n    }\n  }\n}\n\nfragment SetupStartModal_run on Run {\n  id\n  status\n  machine {\n    id\n    type {\n      id\n      name\n    }\n  }\n}\n\nfragment SetupPauseModal_run on Run {\n  id\n  machine {\n    id\n    type {\n      id\n      name\n    }\n  }\n}\n\nfragment SetupEndModal_run on Run {\n  id\n  jobState {\n    id\n    workflowState {\n      id\n      isTrackingSetupQuantity\n    }\n  }\n  yields {\n    edges {\n      node {\n        id\n        quantity\n        item {\n          id\n          name\n          partNumber\n          quantityUOM {\n            id\n            symbol\n          }\n        }\n      }\n    }\n  }\n  machine {\n    id\n    type {\n      id\n      name\n    }\n  }\n}\n\nfragment RunStartModal_run on Run {\n  id\n  status\n  machine {\n    id\n    type {\n      id\n      name\n    }\n  }\n}\n\nfragment RunPauseModal_run on Run {\n  id\n  machine {\n    id\n    type {\n      id\n      name\n    }\n  }\n}\n\nfragment RunEndModal_run on Run {\n  id\n  jobState {\n    id\n    workflowState {\n      id\n      trackRunQuantityType\n      isPromptingFinalQuantity\n      defaultLot {\n        id\n      }\n    }\n  }\n  yields {\n    edges {\n      node {\n        id\n        quantity\n        item {\n          id\n          name\n          partNumber\n          lotTracking\n          quantityUOM {\n            id\n            symbol\n          }\n        }\n      }\n    }\n  }\n  machine {\n    id\n    type {\n      id\n      name\n    }\n  }\n}\n\nfragment ProgressPanel_user on User {\n  id\n  firstName\n  lastName\n  avatar\n  ...UserAvatar_user\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a619995bf6aa08a0d9dd8ccb940d5a1b';
module.exports = node;
